import request from '@/utils/request'
const preFixUrl = '/ws'
/**
 * 获取聊天记录
 * @param {*} data
 * @returns
 */
export const getChatMessage = data => {
  return request({
    url: `${preFixUrl}/chatMessage/listMsgRecord`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 获取在线医生
 * @param {*} data
 * @returns
 */
export const getOnlineDoctorInfo = data => {
  return request({
    url: `${preFixUrl}/ws/getOnlineDoctorInfo`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 查询聊天过的医生
 * @param {*} userNo
 * @returns
 */
export const getdoctorListRecord = userNo => {
  return request({
    url: `${preFixUrl}/chatMessage/doctorList?userNo=${userNo}`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}
